import { Component, inject, type OnDestroy, type OnInit, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { type User } from '@inside-hub-app/customer-portal-b2c-client'
import { CptGoogleTagmanagerService, MatomoIntegrationService } from '@inside-hub-app/customer-portal-shared'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { TranslationService } from '@emilfreydigital/transifex-angular'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { DataService } from '../../../../services/data.service'
import { SharedService } from '../../../../services/shared.service'
import { MatCard } from '@angular/material/card'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { SupportVehicleCardComponent } from '../support-vehicle-card/support-vehicle-card.component'
import { FAQCardComponent } from '../faq-card/faq-card.component'

@Component({
  selector: 'customer-portal-app-support-card',
  standalone: true,
  templateUrl: './support-card.component.html',
  imports: [CommonModule, MatCard, HubChildTranslateModule, SupportVehicleCardComponent, FAQCardComponent]
})
export class SupportCardComponent implements OnInit, OnDestroy {
  private readonly remoteConfigService = inject(EfRemoteConfigurationService<CustomerPortalConfig>)

  sub = {
    onUserLoaded: null
  }

  user: User

  hasFAQ = signal(this.remoteConfigService.get('hasFAQ'))
  hasSupportVehicleCard = signal(this.remoteConfigService.get('hasSupportVehicleCard'))
  supportSubject = signal(this.remoteConfigService.get('support.subject'))

  constructor (
    public sharedService: SharedService,
    private readonly cptGtmService: CptGoogleTagmanagerService,
    private readonly dataService: DataService,
    private readonly transifexTranslationsService: TranslationService,
    private readonly matomoIntegrationService: MatomoIntegrationService
  ) {}

  ngOnInit (): void {
    this.sub.onUserLoaded = this.dataService.onUserLoaded.subscribe(user => {
      this.user = user
    })
  }

  ngOnDestroy (): void {
    this.sharedService.unsubscribe(this.sub)
  }

  openMailClient (): void {
    const email = this.remoteConfigService.get('support.email')
    const subject = this.supportSubject() + ' - ' + String(this.user.contactId)
    const url = 'mailto:' + email + '?subject=' + subject
    window.open(url)
  }

  sendContentModulesCTAData (contentModuleLabel: string): void {
    this.cptGtmService.sendContentModulesData(
      'CTA',
      'Click',
      this.sharedService.translateLink(contentModuleLabel) ?? '',
      'CTA',
      this.sharedService.translateLink(contentModuleLabel) ?? ''
    )

    this.matomoIntegrationService.trackEvent(
      'CTA',
      'Customer portal support click'
    )
  }

  getTranslation (): string {
    return this.transifexTranslationsService.translate(
      'Is your data not displayed correctly? Do you have questions?<br> We are there for you.',
      {
        _key: 'customerPortal.customer-portal.support.contact.title',
        _tags: 'customer-portal, 3.1'
      }
    )
  }
}
